import React, { useRef, useState } from "react";
import SchoolImg from "../../../../../assets/Images/TestImg/SchoolImg.png";
import ProfileImg from "../../../../../assets/Images/TestImg/profileImage.png";
import SignatureImg from "../../../../../assets/Images/TestImg/Signature.png";
import PDFBranding from "../../../../Universal/SAS Branding/PDFBranding.component";
import { Helmet } from "react-helmet";
import DonutChart from "../../../../Universal/DonutChart.component";
import ScrollableCardTable from "../../../../Universal/ScrollableCardTable.component";
// import PageHeader from "../../../UniversalComponents/PageHeader.component";
// import ScrollableCardTable from "../../../../Universal/ScrollableCardTable.component";
// import CardHeader from "../../../../Universal/CardHeader.component";
import html2pdf from "html2pdf.js";
import GradeTable from "./GradeTable.component";

const PerformanceReport = ({ studentData, gradeSystem }) => {
  console.log(studentData);
  const printDocRef = useRef(null);
  const printData = () => {
    if (!printDocRef) return;
    var opt = {
      margin: [0.1, 0.1],
      filename: "myfile.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
    };
    document.body.classList.add("print-mode");
    html2pdf()
      .from(printDocRef.current)
      .set(opt)
      .save()
      .then(() => {
        document.body.classList.remove("print-mode");
      });
  };
  // eslint-disable-next-line
  const [donutChartData, setDonutChartData] = useState([
    { exams: "test", total: 70 },
    { exams: "test2", total: 30 },
    { exams: "test8", total: 10 },
    { exams: "test5", total: 50 },
    { exams: "test5", total: 50 },
    { exams: "test5", total: 50 },
    { exams: "test5", total: 50 },
  ]);
  // eslint-disable-next-line
  const [subjectStrength, setSubjectStrength] = useState([
    {
      subject: "Mathematics",
      strength: 70,
      colors: {
        font: "#85BF52", // Green font
        background: "#F9FFF3", // Light green background
      },
    },
    {
      subject: "English",
      strength: 30,
      colors: {
        font: "#E54EE0", // Pink font
        background: "#FCE4EC", // Light pink background
      },
    },
    {
      subject: "Life Science",
      strength: 10,
      colors: {
        font: "#43BCC9", // Cyan font
        background: "#F0FEFF", // Light cyan background
      },
    },
    {
      subject: "Physical Science",
      strength: 50,
      colors: {
        font: "#DFBE19", // Yellow font
        background: "#FFFDF1", // Light yellow background
      },
    },
    {
      subject: "Bengali",
      strength: 50,
      colors: {
        font: "#FF8266", // Orange-red font
        background: "#FFECEC", // Light red background
      },
    },
    {
      subject: "History",
      strength: 50,
      colors: {
        font: "#516BFF", // Purple font
        background: "#F0F2FF", // Light purple background
      },
    },
    {
      subject: "Geography",
      strength: 50,
      colors: {
        font: "#E54EE0", // Pink font
        background: "#FCE4EC", // Light pink background
      },
    },
  ]);
  // eslint-disable-next-line
  const [examData, setExamData] = useState({
    title: "First Internal Examination",
    subjects: [
      {
        name: "Mathematics",
        code: "MTH",
        type: "Science",
        marks: 91,
        grade: "A+",
      },
      { name: "Physics", code: "PHY", type: "Science", marks: 91, grade: "A+" },
      {
        name: "Chemistry",
        code: "CHM",
        type: "Science",
        marks: 91,
        grade: "A+",
      },
      { name: "History", code: "HIS", type: "Arts", marks: 91, grade: "A+" },
      {
        name: "Economics",
        code: "ECO",
        type: "Commerce",
        marks: 91,
        grade: "A+",
      },
      {
        name: "Political Science",
        code: "POL",
        type: "Arts",
        marks: 91,
        grade: "A+",
      },
      {
        name: "Computer Science",
        code: "CSE",
        type: "Technology",
        marks: 91,
        grade: "A+",
      },
      {
        name: "Business Studies",
        code: "BUS",
        type: "Commerce",
        marks: 91,
        grade: "A+",
      },
      { name: "Law", code: "LAW", type: "Law", marks: 91, grade: "A+" },
    ],
  });
  return (
    <section className="w-full flex-col align-start g-1 justify-start">
      <Helmet>
        <title>Student Performance Report</title>
        <meta
          name="description"
          content="To view students performance report and you can also download the report as a pdf"
        />
      </Helmet>
      <div className="w-full flex-row align-center justify-end g-1">
        <button className="actionBtn">Download Marks</button>
        <button onClick={printData} className="actionBtn">
          Download
        </button>
      </div>
      {/* white back card  for print */}
      <div
        ref={printDocRef}
        className="w-full flex-col align-start g-2 justify-start back-white p-1 p-l-2 p-r-2 p-b-3"
      >
        {/* header */}
        <div className="flex-col align-center justify-start g-2">
          <div className="flex-col align-center justify-start g-1">
            <img
              src={SchoolImg}
              style={{ width: "8rem", height: "8rem", objectFit: "cover" }}
              alt=""
            />
            <h3 className="f-24 poppins weight-500">
              Elementary School of Business and Social Sciences
            </h3>
          </div>
          <div className="w-full flex-col align-center justify-start g-2">
            <p className="t-16 color-grayColor poppins">Attendance report</p>
            <hr className="w-full" color="#b0b0b0" />
          </div>
        </div>
        <div className="flex-row align-start justify-between">
          <div
            className="flex-row align-center justify-start g-1"
            style={{ height: "5rem" }}
          >
            <img
              src={ProfileImg}
              style={{ width: "5rem", height: "5rem", borderRadius: "50%" }}
              alt=""
            />
            <div className="h-full flex-col align-start justify-center">
              <h3 className="t-20 poppins weight-500">
                {studentData && studentData.name}
              </h3>
              <p className="t-14 poppins color-textGray">
                ID: {studentData && studentData.id}{" "}
              </p>
            </div>
          </div>
          {/* profile card sub  sec */}

          <div
            className="flex-row align-center justify-center g-2"
            style={{ height: "5rem" }}
          >
            <div className="flex-col align-start justfy-center g-1">
              <div className="flex-row align-center justify-start">
                <span className="poppins t-14">Class:</span>
                <span
                  className="poppins t-14"
                  style={{ color: "var(--greenColor)" }}
                >
                  {studentData && studentData.academic.currentClass}
                </span>
              </div>
              <div className="flex-row align-center justify-start">
                <span className="poppins t-14">Section:</span>
                <span
                  className="poppins t-14"
                  style={{ color: "var(--greenColor)" }}
                >
                  {studentData && studentData.academic.section}
                </span>
              </div>
            </div>
            <div className="flex-col align-start justfy-center g-1">
              <div className="flex-row align-center justify-start">
                <span className="poppins t-14">Roll:</span>
                <span
                  className="poppins t-14"
                  style={{ color: "var(--greenColor)" }}
                >
                  {studentData && studentData.academic.rollNo}
                </span>
              </div>

              <div className="flex-row align-center justify-start">
                <span className="poppins t-14">Stars:</span>
                <span
                  className="poppins t-14"
                  style={{ color: "var(--greenColor)" }}
                >
                  {studentData && "20"}
                </span>
              </div>
            </div>
            <div className="flex-col align-start justfy-center g-1">
              <div className="flex-row align-center justify-start">
                <span className="poppins t-14">Date of Admission:</span>
                <span
                  className="poppins t-14"
                  style={{ color: "var(--greenColor)" }}
                >
                  {studentData && studentData.academic.admissionData}
                </span>
              </div>
              <div className="flex-row align-center justify-start">
                <span className="poppins t-14">Date of Passing:</span>
                <span
                  className="poppins t-14"
                  style={{ color: "var(--greenColor)" }}
                >
                  {studentData && studentData.academic.endSession}
                </span>
              </div>
            </div>
          </div>
          <div
            className="flex-col align-center justify-start g-1"
            style={{ width: "16vw" }}
          >
            <div
              className="flex-col align-center justify-start g-1 radius-6 p-05"
              style={{
                border: "2px solid var(--orangeColor1)",
                overflow: "hidden",
              }}
            >
              <img
                src={SignatureImg}
                style={{ width: "14vw", height: "6rem" }}
                alt=""
              />
              <div className="poppins t-14">Teacher in Charge</div>
            </div>
          </div>
        </div>

        {/* start from here */}
        <div className="w-full flex-row align-start justify-start g-1">
          <div
            className="flex-col align-start justify-start g-1"
            style={{ width: "66%" }}
          >
            <h3 className="weight-500 t-18 color-grayColor poppins">Overall</h3>
            <table id="studentGradeTable">
              <thead>
                <tr>
                  <th>Subjects</th>
                  <th>Subject wise grade</th>
                  <th>Over all grade</th>
                </tr>
              </thead>
              <tbody>
                {studentData &&
                  studentData.grades.map((grade, index) => {
                    return (
                      <tr>
                        <td>{grade.subject}</td>
                        <td aria-label={grade.grade}>{grade.grade}</td>
                        {index === 0 && (
                          <td rowSpan={3} overAllGrade="AA">
                            AA
                          </td>
                        )}{" "}
                        {index === 3 && (
                          <td
                            style={{
                              background: "var(--tableBackColor)",
                              color: "var(--tableColor) !important",
                            }}
                          >
                            Grade chart
                          </td>
                        )}{" "}
                        {index === 4 && (
                          <td rowSpan={3}>
                            <table
                              style={{ borderCollapse: "collapse" }}
                              id="showGradeSystem"
                            >
                              <tbody>
                                {gradeSystem &&
                                  gradeSystem.map((items) => {
                                    return (
                                      <tr>
                                        <td>{items.grade}</td>
                                        <td>{items.percentage}</td>
                                        <td className="flex">
                                          <span
                                            style={{
                                              width: "0.7rem",
                                              height: "0.7rem",
                                              borderRadius: "2px",
                                              background: items.color,
                                            }}
                                          ></span>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </td>
                        )}{" "}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div
            className="h-fit flex-col align-start justify-start"
            style={{ width: "44%", gap: "4.1rem" }}
          >
            {/* docut chart list */}
            <div className="flex-row align-center justify-between g-1">
              <DonutChart
                data={donutChartData}
                valuemapKey={"total"}
                title={"Important Exams"}
              />
              {/* <table>
                <thead>
                  <tr>
                    <th>Exams</th>
                  </tr>
                </thead>
              </table> */}
              <ScrollableCardTable thead={["Exams", "Total", "%"]}>
                {donutChartData &&
                  donutChartData.map((data) => {
                    return (
                      <tr className="pollingDetailsTableData w-full flex-row align-center justify-arround">
                        <td>{data.exams}</td>
                        <td>{data.total}</td>
                        <td>0.00%</td>
                      </tr>
                    );
                  })}
              </ScrollableCardTable>
            </div>
            {/* performance sec short card */}
            <div
              className="w-full flex-row align-center justify-center radius-6 p-1"
              style={{
                background: "var(--shadeGreen)",
                border: "2px solid var(--deepGreen3)",
              }}
            >
              <div className="w-half h-full flex-col align-center justify-center g-05">
                <span
                  style={{ color: "var(--deepGreen4)" }}
                  className="t-18 poppins"
                >
                  Performance
                </span>
                <span className="t-25 color-deepGreen3 poppins">23/23</span>
              </div>
              <div className="w-half h-full flex-row align-center justify-center ">
                <span className="t-30 color-deepGreen3 poppins">86.</span>
                <span className="t-25 color-deepGreen3 poppins">52</span>
                <span className="t-30 color-deepGreen3 poppins">%</span>
              </div>
            </div>
          </div>
        </div>
        {/* position and ovarall marks */}
        <div className="flex-row align-center justify-between g-1">
          <div
            className="flex-row align-center justify-between radius-6 overflow-hide"
            style={{
              border: "2px solid var(--tableBorderColor)",
              height: "4rem",
              width: "66%",
            }}
          >
            <div
              className="w-half h-full flex align-center justify-center t-30 poppins"
              style={{
                background: "var(--tableBackColor)",
                borderRight: "2px solid var(--tableBorderColor)",
                color: "var(--tableColor)",
              }}
            >
              Overall Marks
            </div>
            <div
              className="w-half flex align-center justify-center t-30 poppins"
              style={{ color: "var(--blueColor2)" }}
            >
              1200/1500
            </div>
          </div>
          <div
            className="flex-row align-center justify-between radius-6 overflow-hide"
            style={{
              border: "2px solid var(--tableBorderColor)",
              height: "4rem",
              width: "44%",
            }}
          >
            <div
              className="w-half h-full flex align-center justify-center t-30 poppins"
              style={{
                background: "var(--tableBackColor)",
                borderRight: "2px solid var(--tableBorderColor)",
                color: "var(--tableColor)",
              }}
            >
              Position
            </div>
            <div
              className="w-half flex align-center justify-center t-30 poppins"
              style={{ color: "var(--blueColor2)" }}
            >
              89
            </div>
          </div>
        </div>

        {/* page break for print the pdf */}
        <div className="html2pdf__page-break"></div>
        {/* Categorical Strength  section*/}
        <div className="flex-col align-start justify-start g-1">
          <h3 className="t-15 poppins color-grayColor weight-500">
            Categorical Strength
          </h3>
          <div className="studentProfileCatagoricalStrength flex-row align-center justify-between g-3">
            <div>
              <span>Scicnce</span>
              <span>39.37%</span>
            </div>
            <div>
              <span>Arts</span>
              <span>39.37%</span>
            </div>
            <div>
              <span>Management</span>
              <span>39.37%</span>
            </div>
          </div>
        </div>
        {/* subject strength */}
        <div className="flex-col align-start justify-start g-1">
          <h3 className="t-15 poppins color-grayColor weight-500">
            Categorical Strength
          </h3>
          <div className="studentSubjectStrength">
            {subjectStrength &&
              subjectStrength.map((strength, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      "--subjectStrangthBackColor": strength.colors.background,
                      "--subjectStrangthFontColor": strength.colors.font,
                    }}
                  >
                    <span>{strength.subject}</span>
                    <span>{strength.strength}</span>
                  </div>
                );
              })}
          </div>
        </div>
        {/* student grade cards */}

        <div className="flex-col align-start justify-start g-1">
          <h3 className="t-15 poppins color-grayColor weight-500">
            Categorical Strength
          </h3>

          <div className="studentGradeCardsContainer">
            <GradeTable
              thead={[
                "SubjectName",
                "Subject code",
                "Subject type",
                "Marks(%)",
                "Grade",
              ]}
              title={examData.title}
              tbody={examData.subjects}
            />
            <div className="html2pdf__page-break"></div>

            <GradeTable
              thead={[
                "SubjectName",
                "Subject code",
                "Subject type",
                "Marks(%)",
                "Grade",
              ]}
              title={examData.title}
              tbody={examData.subjects}
            />
            <div className="html2pdf__page-break"></div>

            <GradeTable title={examData.title} tbody={examData.subjects} />
            <div className="html2pdf__page-break"></div>

            <GradeTable title={examData.title} tbody={examData.subjects} />
          </div>
        </div>

        <div className="flex-col g-1 align-start justify-start">
          <p className="t-14 color-grayColor poppins-medium">
            Date: 02 Oct, 2024
          </p>
          <div className="flex-row align-center justify-between">
            <div
              style={{ width: "25vw" }}
              className="flex-col align-start justify-start g-05"
            >
              <h3 className="poppins-medium t-18 weight-500">
                Elementary School of Business and Social Sciences
              </h3>
              <address className="poppins t-14">
                15, Grand Trunk Rd, Deshbandhu Park, Uttarpara, Kolkata, West
                Bengal 700134
              </address>
            </div>

            <div className="flex-col align-center justify-center g-1">
              <img
                src={SignatureImg}
                style={{
                  width: "14rem",
                  height: "4.5rem",
                  objectFit: "contain",
                }}
                alt=""
              />
              <hr color="black" className="w-full" />
              <div className="poppins t-14 p-05">
                Authorized Signatory (Academic head)
              </div>
            </div>
          </div>
        </div>
      </div>

      <PDFBranding />
    </section>
  );
};

export default PerformanceReport;
